window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function(e) {

      //console.log(e);
      //$(this.singleOptionSelector).val(this.value);


      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Modules ================*/
(function($) {

  $.fn.magazine = function(options) {

    // Default Options
    var settings = $.extend({
      src: '',
      ratio: 1,
      container: null,
      mobileBreakpoint: 400,
      hasHardcover: false,
      allowZoom: false,
      onTurning: function(){}, 
      onTurned: function(){}, 
      onStart: function(){}, 
      onEnd: function(){}, 
      onFirst: function(){},
      onLast: function(){},
      onResize: function(){},
      onZoomIn: function(){},
      onZoomOut: function(){}
    }, options);

    return this.each(function() {
      var $book = $(this),
          $magazineWrapper = $book.parents('.magazine-wrapper'),
          $magazineViewport = $book.parents('.magazine-viewport'),
          pdfDoc = null,
          pdfLoading = false,
          lastPage = 1,
          pageNum = 1,
          allPages = 0,
          pageRendering = false,
          pageNumPending = null,
          pageNumLoaded = null;


      //alert($book.attr('class'));
      //console.log('magazine_init', $book.attr('class'));
          
      // Turn.js
      $book.show().turn({
        page: 1,
        duration: 1500,
        width: $magazineWrapper.width(),
        height: $magazineWrapper.width() * settings.ratio / 2,
        autoCenter: true,
        elevation: 50,
        gradients: true,
        acceleration: !isChrome(),
        when: {
          turning: function(event, page, view) {
            // load PDF on first user interaction
            if(!pdfLoading && !pdfDoc) {
              _loadPDF(settings.src);
            }

            // Show and hide navigation buttons
            updateControls(page);
            settings.onTurning(event, page, view);
          },
          turned: function(event, page, view) {
            var offset = settings.hasHardcover ? 2 : 1;
            lastPage = page;

            if(pdfDoc) {
              view.forEach(function(item){
                if(item > offset) {
                  _queueRenderPage(item - offset);
                }
              });
            }    

            // Show and hide navigation buttons
					  updateControls(page);
            settings.onTurned(event, page, view);
          },
          start: function(event, pageObject, corner) {
            settings.onStart(event, pageObject, corner);
          },
          end: function(event, pageObject, corner) {
            settings.onEnd(event, pageObject, corner);
          },
          first: function(event) {
            settings.onFirst(event);
          },
          last: function(event) {
            settings.onLast(event);
          }
        }
      }); 


      // Zoom.js
      /*
      $magazineViewport.zoom({
        flipbook: $book,
        max: function() {  return largeMagazineWidth()/$book.width(); }, 
        max: 1,
        when: {
          swipeLeft: function() {
            $(this).zoom('flipbook').turn('next');
          },
          swipeRight: function() {
            $(this).zoom('flipbook').turn('previous');
          },
          resize: function(event, scale, page, pageElement) {
            if (scale==1)
              _renderPage(page);
              //loadSmallPage(page, pageElement);
            else
              _renderPage(page);
              //loadLargePage(page, pageElement);
          },
          zoomIn: function () {
            $('.thumbnails').hide();
            $('.made').hide();
            $book.removeClass('animated').addClass('zoom-in');
            $('.zoom-icon').removeClass('zoom-icon-in').addClass('zoom-icon-out');
            
            if (!window.escTip && !$.isTouch) {
              escTip = true;

              $('<div />', {'class': 'exit-message'}).
                html('<div>Press ESC to exit</div>').
                  appendTo($('body')).
                  delay(2000).
                  animate({opacity:0}, 500, function() {
                    $(this).remove();
                  });
            }
          },
          zoomOut: function () {
            $('.exit-message').hide();
            $('.thumbnails').fadeIn();
            $('.made').fadeIn();
            $('.zoom-icon').removeClass('zoom-icon-out').addClass('zoom-icon-in');

            setTimeout(function(){
              $book.addClass('animated').removeClass('zoom-in');
              //resizeViewport();
            }, 0);
          }
        }
      });
      */
      
      if(settings.allowZoom) {
        $magazineViewport.zoom({
          flipbook: $book,
          max: 1.5, 
          when: {
            swipeLeft: function() {
              $(this).zoom('flipbook').turn('next');
            },
            swipeRight: function() {
              $(this).zoom('flipbook').turn('previous');
            },
            resize: function(event, scale, page, pageElement) {
              //console.log('###', event, scale, page, pageElement);
            },
            zoomIn: function () {
              $book.removeClass('animated').addClass('zoom-in');
              
              settings.onZoomIn();
            },
            zoomOut: function () {
              setTimeout(function(){
                $book.addClass('animated').removeClass('zoom-in');
                $(window).resize();
              }, 0);
              
              settings.onZoomOut();
            }
          }
        });
        // Zoom event
        if ($.isTouch)
          $magazineViewport.bind('zoom.doubleTap', zoomTo);
        else
          $magazineViewport.bind('zoom.tap', zoomTo);
      }

      // Zoom in / Zoom out
      function zoomTo(event) {
        setTimeout(function() {
          if ($magazineViewport.data().regionClicked) {
            $magazineViewport.data().regionClicked = false;
          } else {
            if ($magazineViewport.zoom('value')==1) {
              $magazineViewport.zoom('zoomIn', event);
            } else {
              $magazineViewport.zoom('zoomOut');
            }
          }
        }, 1);
      }
      // Width of the flipbook when zoomed in
      function largeMagazineWidth() {
        return 2214;
      }




      // Resize event
      var resizeViewport = function() {
        
        $book.removeClass('animated');

        var width = $magazineWrapper.width(),
            height = Math.round(width * settings.ratio / 2),
            padded = Math.round(document.body.clientHeight * 0.9);

        if(width < settings.mobileBreakpoint) {
          height = height * 2;
        }

        // if the height is too big for the window, constrain it
        if (height > padded) {
            height = padded;
            width = Math.round(height / settings.ratio) * 2;
            if(width < settings.mobileBreakpoint) {
              width = Math.round(height * settings.ratio) * 2;
            }
        }

        // set the width and height matching the aspect ratio
        $book.css({
          width: width,
          height: height
        });
        
        // Zoom Viewport resize
        $magazineViewport.css({
          width: width,
          height: height
        });
        
        $book.turn('size', width, height);
        if(width < settings.mobileBreakpoint) {
          $book.turn("display", "single");
        } else {
          $book.turn("display", "double");
        }
        $book.turn('resize');
        
        if(settings.allowZoom) {
          $magazineViewport.zoom('resize');
        }
        settings.onResize();

        $book.addClass('animated');

        return {
          width: width,
          height: height
        };
      }


      $(window).resize(function() {
        resizeViewport();
      }).bind('orientationchange', function() {
        resizeViewport();
      });

      
      setTimeout(function() {
        $(window).resize();
      }, 100);
      








      // Using arrow keys to turn the page
      $(document).keydown(function(e){
        var previous = 37, next = 39, esc = 27;

        switch (e.keyCode) {
          case previous:
            // left arrow
            $book.turn('previous');
            e.preventDefault();
          break;
          case next:
            //right arrow
            $book.turn('next');
            e.preventDefault();
          break;
          case esc:
            $magazineViewport.zoom('zoomOut');	
            e.preventDefault();
          break;
        }
      });
  

      // Events for the next button
      $book.find('.next-button').bind($.mouseEvents.over, function() {
        $(this).addClass('next-button-hover');
      }).bind($.mouseEvents.out, function() {
        $(this).removeClass('next-button-hover');
      }).bind($.mouseEvents.down, function() {
        $(this).addClass('next-button-down');
      }).bind($.mouseEvents.up, function() {
        $(this).removeClass('next-button-down');
      }).click(function() {
        $book.turn('next');
      });

      // Events for the previous button
      $book.find('.previous-button').bind($.mouseEvents.over, function() {
        $(this).addClass('previous-button-hover');
      }).bind($.mouseEvents.out, function() {
        $(this).removeClass('previous-button-hover');
      }).bind($.mouseEvents.down, function() {
        $(this).addClass('previous-button-down');
      }).bind($.mouseEvents.up, function() {
        $(this).removeClass('previous-button-down');
      }).click(function() {
        $book.turn('previous');
      });

      $magazineWrapper.bind('mouseenter', function() {
        if($book.turn('page') == 1) {
          $(this).find('.next-button').addClass('next-button-hover');
        }
      }).bind('mouseleave', function() {
        $(this).find('.next-button').removeClass('next-button-hover');
      });

      $magazineWrapper.find('.controls .prev').unbind('click').bind('click', function() {
        $book.turn('previous');
      });
      $magazineWrapper.find('.controls .next').unbind('click').bind('click', function() {
        $book.turn('next');
      });


     
      //_loadPDF(settings.src);


      function _loadPDF(src) {

        //console.log('_loadPDF', src);
        if(src == '') 
          return false;

        pdfLoading = true;

        // Loaded via <script> tag, create shortcut to access PDF.js exports.
        var pdfjsLib = window['pdfjs-dist/build/pdf'];

        // The workerSrc property shall be specified.
        //pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
        //pdfjsLib.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
        pdfjsLib.workerSrc = window.theme.mediaPlayer.pdfWorkerUrl;
        pdfjsLib.disableWorker = true;

        //alert(pdfjsLib.workerSrc)
        //var loadingTask = pdfjsLib.getDocument({data: pdfData});
        //loadingTask.promise.then(function(doc) {
        pdfjsLib.getDocument(src).then(function(doc) {

          pdfLoading = false,
          pdfDoc = doc;
          allPages = settings.hasHardcover ? pdfDoc.numPages + 2 : pdfDoc.numPages + 1;


          updateControls(1);
          //document.getElementById('page_count').textContent = pdfDoc.numPages;

          var pOffset = settings.hasHardcover ? 2 : 1;

          for(var i=1; i<=(pdfDoc.numPages); i++) {
            var realPageNum = i + pOffset;
            element = $("<div />", {"class": "p"+realPageNum}).html('<div class="loader"></div><canvas id="page-canvas-'+ i +'"></canvas><div class="gradient"></div>');
            $book.turn("addPage", element, realPageNum);
          }
          // Initial/first page rendering
          _renderPage(1);
          _queueRenderPage(2);
        });
      }

      function _renderPage(num) {

        if(!$book.find('#page-canvas-' + num).attr('rendered')) {

          pageRendering = true;

          // Using promise to fetch the page
          pdfDoc.getPage(num).then(function(page) {
            var canvas = $book.find('#page-canvas-' + num)[0];
            var ctx = canvas.getContext('2d');
            var viewport = page.getViewport(settings.ratio);
            canvas.height = viewport.height;
            canvas.width = viewport.width;
        
            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: ctx,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
        
            // Wait for rendering to finish
            renderTask.promise.then(function() {
              pageRendering = false;
              $book.find('#page-canvas-' + num).attr('rendered', 'true');
              $book.find('#page-canvas-' + num).siblings('.loader').addClass('hide');
              if (pageNumPending !== null && typeof pageNumPending !== 'undefined') {
                // New page rendering is pending
                _renderPage(pageNumPending);
                pageNumPending = null;
              }
            });
          });
        
          // Update page counters
          //document.getElementById('page_num').textContent = num;          
        }
      }

      /**
       * If another page rendering in progress, waits until the rendering is
       * finised. Otherwise, executes rendering immediately.
       */
      function _queueRenderPage(num) {
        if (pageRendering) {
          pageNumPending = num;
        } else {
          _renderPage(num);
        }
      }

      /**
       * Displays previous page.
       */
      function _onPrevPage() {
        if (pageNum <= 1) {
          return;
        }
        pageNum--;
        _queueRenderPage(pageNum);
      }

      /**
       * Displays next page.
       */
      function _onNextPage() {
        //console.log(pageNum);
        if (pdfDoc) {
          if (pageNum >= pdfDoc.numPages) {
            return;
          };
          pageNum++;
          _queueRenderPage(pageNum);
        }
      }

      function isChrome() {
        return navigator.userAgent.indexOf('Chrome')!=-1;
      }
      
      function updateControls(page) {
        if (page==1)
          $book.find('.previous-button').addClass('hide');
        else
          $book.find('.previous-button').removeClass('hide');
              
        if (page==$('.magazine').turn('pages'))
          $book.find('.next-button').addClass('hide');
        else
          $book.find('.next-button').removeClass('hide');

        var pOffset = settings.hasHardcover ? 2 : 1;
        $magazineWrapper.find('.controls .count').text(page + '/' + (allPages + pOffset));
      }

    });
  }
}(jQuery));
/**
 * Product Multimedia Player Script
 * ------------------------------------------------------------------------------
 *
 * @namespace multimediaPlayer
 */

theme.MultimediaPlayer = (function() {

  

  function MultimediaPlayer(options) {
    //console.log('MultimediaPlayer()');
    let self = this;

    this.autoHeight = options.autoHeight ? true : false;
    this.$container = options.$container;
    this.$productMediaPlayer = this.$container.find('.product-media-player');
    this.$mediaSlider = this.$container.find('.product-media-player .magazine-wrapper');


    if(this.$productMediaPlayer.data('direction') == 'vertical') {
      this.initScrollMode();
    } else {
      this.initSlider();
    }

    this.initThumbSlider();
    this.initMediaPlayer();
    this.initAudioPlayer();
    this.initFlippingBook(null);
    this.initMediaPopup();


    // InstantClick 
    if(theme.settings.instantMode) {
      InstantClick.on('beforeunload', function() {
        //this.$container.off(this.namespace);
        self.destroyAllVideoPlayers();
        self.destroyAllAudioPlayers();
        //alert('beforeunload');
      });
    }
  }



  MultimediaPlayer.prototype = $.extend({}, MultimediaPlayer.prototype, {

    pageNum: 1,

    initScrollMode: function() {
      let self = this;
      const breakpoint = window.matchMedia( '(min-width:768px)' );
      const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
          self.$productMediaPlayer.addClass('scroll-mode-active');
          if ( self.galleryTop !== undefined ) {
            self.galleryTop.destroy( true, true );
            self.galleryTop = undefined;
          }
          return;
        } else if ( breakpoint.matches === false ) {
          self.$productMediaPlayer.removeClass('scroll-mode-active');
          self.initSlider();
          //return self.initSlider();
          return true;
        }
      };
      // keep an eye on viewport size changes
      breakpoint.addListener(breakpointChecker);
      // kickstart
      breakpointChecker();
    },


    initSlider: function() {
      let direction = this.$productMediaPlayer.data('direction'),
          mouseDownContent = false,
          cursorOverContent = false,
          self = this;

      // Gallery Slider
      if(this.$container.find('.gallery-top').length > 0) {
        this.galleryTop = new Swiper(this.$container.find('.gallery-top')[0], {
          init: false,
          threshold: 5,
          autoHeight: this.autoHeight,
          //direction: this.$productMediaPlayer.data('direction'),
          initialSlide: 0,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          spaceBetween: 10,
        });
        this.galleryTop.on('transitionStart', function (e) {
          self.$container.find('.swiper-slide').removeClass('opacity-0');
        });
        this.galleryTop.on('transitionEnd', function (e) {
          //console.log('transitionEnd', self.activePlayerIndex, self.slideshow.realIndex);
          var $currentSlide = self.galleryTop.$el.find('.swiper-slide-active');
          //self.galleryTop.allowTouchMove = ($currentSlide.find('.ebook-content').length > 0) ? false : true;

          if(!$currentSlide.find('.ebook-content').length) {
            self.$container.find('.swiper-slide').removeClass('opacity-0');
          }

          self.pauseAllPlayingVideos();
          self.pauseAllPlayingAudios();
        });
        this.galleryTop.on('init', function() {
          self.conncectSliders();
        });
        this.galleryTop.init();
        

        //if(self.galleryTop.$el.find('.swiper-slide-active .ebook-content').length > 0) {
        //  self.galleryTop.allowTouchMove = false;
        //} 
        this.$productMediaPlayer.find('.magazine, .player').bind('mouseenter', function() {
          cursorOverContent = true;
          if(typeof(self.galleryTop) !== 'undefined') self.galleryTop.allowTouchMove = false;
        }).bind('mouseleave', function() {
          cursorOverContent = false;
          if(!mouseDownContent)
            if(typeof(self.galleryTop) !== 'undefined') self.galleryTop.allowTouchMove = true;
        }).bind('mousedown', function() {
          mouseDownContent = true;
        });
        $('body').bind('mouseup', function() {
          mouseDownContent = false;
          if(!cursorOverContent)
            if(typeof(self.galleryTop) !== 'undefined') self.galleryTop.allowTouchMove = true;
        });
      }
      
    },
    initThumbSlider: function() {
      let self = this;

      // Thumbnail Slider
      if(this.$container.find('.gallery-thumbs').length > 0) {
        this.galleryThumbs = new Swiper(this.$container.find('.gallery-thumbs')[0], {
          init: false,
          threshold: 5,
          initialSlide: 0,
          spaceBetween: 0,
          touchRatio: 0.2,
          slidesPerView: 'auto',
          //direction: this.$productMediaPlayer.data('direction'),
          centeredSlides: true,
          slideToClickedSlide: true
        });
        this.galleryThumbs.on('init', function() {
          self.conncectSliders();
        });
        this.galleryThumbs.init();
      }
    },
    conncectSliders: function() {
      let self = this;
      //return false;
      // Slider connecten
      if(self.galleryTop && self.galleryThumbs) {
        //setTimeout(function() {
          self.galleryTop.slideTo(0);
          self.galleryThumbs.slideTo(0);
          self.galleryTop.controller.control = self.galleryThumbs;
          self.galleryThumbs.controller.control = self.galleryTop;
        //}, 200);     
      }   
    },





    /**
     * ------------------------------------------------------------------------------
     *  Audio Player
     * ------------------------------------------------------------------------------
     * 
     *
     *  
     */
    audioPlayers: [],
    wavesurfer: null,
    wavesurferRefs: [],
    initAudioPlayer: function() {
      let self = this;
      let autoPlay = false;
      let wavesurfer = null;

      self.destroyAllAudioPlayers();

      $('.audio-content').each(function() {
        let $target = $(this);
        let $player = $target.find('.player');
        let $playBtn = $target.find('.play-btn');
        let $coverBtn = $target.find('.cover-btn');
        let $playlistItems = $target.find('.list a.item');
        let $waveform = $target.find('.audio-wave');
        let mediaSrc = $target.find('.waveform').data('media-src');
        let audioSettings = {
          container: '#' + $target.find('.waveform').attr('id'),
          hideScrollbar: true,
          barWidth: 3,
          barHeight: 1,
          height: 75,
          normalize: true,
          responsive: true,
          //splitChannels: true,
          plugins: [
            WaveSurfer.cursor.create({
              showTime: true,
              opacity: 1,
              customShowTimeStyle: {
                'background-color': '#000',
                color: '#fff',
                padding: '2px',
                'font-size': '10px',
                'margin-top': '37px'
              }
            })
          ]
        }
        if(theme.cartPlaylist.audioCtx !== undefined) {
          audioSettings.audioContext = theme.cartPlaylist.audioCtx;
        }

        if(typeof mediaSrc !== 'undefined' && self.audioPlayers.indexOf(mediaSrc) === -1) {
          //self.audioPlayers.push(mediaSrc);

          // Mobile View
          const breakpoint = window.matchMedia( '(min-width: calc(500px + 2rem)' );
          const breakpointChecker = function() {
            if(breakpoint.matches === true) {
              wavesurfer = WaveSurfer.create(Object.assign(audioSettings, {
                scrollParent: false,  // true for mobile
                autoCenter: false,    // true for mobile
              }));
            } else if(breakpoint.matches === false) {
              wavesurfer = WaveSurfer.create(Object.assign(audioSettings, {
                scrollParent: true,  // true for mobile
                autoCenter: true,    // true for mobile
              }));
            }
          };
          // keep an eye on viewport size changes
          //breakpoint.addListener(breakpointChecker);
          breakpointChecker();

          self.wavesurferRefs.push(wavesurfer);
          //wavesurfer.setVolume(0);
          //wavesurfer.load(mediaSrc);


          // Toggle play/pause text
          wavesurfer.on('loading', function() {
            $target.find('.loader').removeClass('hide');
            $waveform.find('wave').eq(1).addClass('hide');
          });
          wavesurfer.on('play', function() {
            $player.find('.play-btn').hide();
            $playBtn.find('.icon').removeClass('play').addClass('pause');
            $playlistItems.find('.icon').removeClass('play').addClass('pause');
          });
          wavesurfer.on('pause', function() {
            $player.find('.play-btn').show();
            $playBtn.find('.icon').removeClass('pause').addClass('play');
            $playlistItems.find('.icon').removeClass('pause').addClass('play');
          });

          $playBtn.bind('click', function() {
            wavesurfer.playPause();
          });
          $coverBtn.bind('click', function(e) {
            e.preventDefault();
            wavesurfer.playPause();
          });

          // The playlist links
          var links = $playlistItems;
          var currentTrack = 0;

          // Load a track by index and highlight the corresponding link
          var setCurrentSong = function(index) {
            if(links.length > 0) {
              links[currentTrack].classList.remove('active');
              currentTrack = index;
              links[currentTrack].classList.add('active');
              wavesurfer.load(links[currentTrack].href);
            }
          };

          // Load the track on click
          Array.prototype.forEach.call(links, function(link, index) {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              setCurrentSong(index);
            });
            $(link).find('.icon').bind('click', function(e) {
              wavesurfer.playPause();
              return false;
            });
          });

          // Play on audio load
          wavesurfer.on('ready', function() {
            if(autoPlay) {
              wavesurfer.play();
            }
            autoPlay = true;
            
            $target.find('.loader').addClass('hide');
            $waveform.find('wave').eq(1).removeClass('hide');

            // Adjust main slider height
            if(typeof(self.galleryTop) !== 'undefined') 
              self.galleryTop.updateAutoHeight();
          });

          // Go to the next track on finish
          wavesurfer.on('finish', function() {
            setCurrentSong((currentTrack + 1) % links.length);
          });

          // Load the first track
          setCurrentSong(currentTrack);
        }
        $player.find('.open-playlist-btn').bind('click', function() {
          $player.find('.playlist-container').toggleClass('show');
        });
        $player.find('.close-playlist-btn').bind('click', function() {
          $player.find('.playlist-container').toggleClass('show');
        });
        $(window).resize(function() {
          if($player.parent().width() > 500) {
            $player.removeClass('mobile');
            $waveform.removeClass('mobile');
          } else {
            $player.addClass('mobile');
            $waveform.addClass('mobile');
          }
          $player.find('.playlist-container').removeClass('show');
        })

        // Player fadeIn
        $player.find('img').on('load', function() {
          if(!$player.hasClass('loaded')) {
            $player.addClass('loaded').transition('fade in');
          }
        }).each(function() {
          if(this.complete) $(this).load();
        });
      });
    },
    pauseAllPlayingAudios: function() {
      var self = this;
      self.wavesurferRefs.forEach(function(wavesurfer) {
        wavesurfer.pause();
      });
    },
    destroyAllAudioPlayers: function() {
      var self = this;
      if(self.wavesurferRefs.length) {
        self.wavesurferRefs.forEach(function(wavesurfer) {
          wavesurfer.empty();
          wavesurfer.destroy();
        });
        self.wavesurferRefs = [];
        self.audioPlayers = [];
      }
    },





    /**
     * ------------------------------------------------------------------------------
     *  Video Player
     * ------------------------------------------------------------------------------
     * 
     * 
     * 
     */
    initMediaPlayer: function() {
      var self = this;

      if(this.$container.find('.js-player').length > 0) {
        //const players = this.$container.find('.js-player').map(p => { return new Plyr(p); });
        //if(this.players) alert(this.players.length);
        this.players = Plyr.setup('.js-player');

        // Bind event listener
        function on(selector, type, callback) {
          document.querySelector(selector).addEventListener(type, callback, false);
        }

        this.$container.find('.plyr').each(function(index) {
          var $cover = $(this).parents('.video-content').find('.cover');

          // Play
          $cover.unbind('click').bind('click', () => { 
            self.players[index].play();
            $cover.find('.loader').removeClass('hide');
          });    
          
          self.players[index].on('playing', event => {
            //const instance = event.detail.plyr;
            if($cover.transition('is visible')) {
              $cover.transition('fade out');
              $cover.find('.loader').addClass('hide');
            }
          });
          
          self.players[index].on('ended', event => {
            //const instance = event.detail.plyr;
            $cover.transition('fade in');
          });
        });

        if(typeof(this.galleryTop) !== 'undefined') this.galleryTop.updateAutoHeight();
      }
    },
    pauseAllPlayingVideos: function() {
      var self = this;
      this.$container.find('.plyr').each(function(index) {
        if(self.players[index].playing) {
          self.players[index].pause();
        }
      });
    },
    destroyAllVideoPlayers: function() {
      var self = this;
      this.$container.find('.plyr').each(function(index) {
        self.players[index].destroy();
      });
    },





    /**
     * ------------------------------------------------------------------------------
     *  PDF Flippingbook Reader
     * ------------------------------------------------------------------------------
     * 
     *  $target (optional) // Entpricht einem .ebook-content Element
     * 
     *
     */
    initFlippingBook: function($target) {
      var self = this;
      var lastPage = 1;

      /*
      if($target) {
        var $book = $target.find('.markup-holder .magazine');
      } else {
        this.$bookContainer = this.$container.find('.product-media-player .magazine-wrapper');
        var $bookContent = this.$bookContainer.parent('.ebook-content');
        var $book = $bookContent.find('.magazine').first();
      }
      */

      var $book = this.$container.find('.magazine');

      if($book.length == 0) {
        return false;
      }
      
      $book.magazine({
        src: $book.data('src'),
        ratio: $book.data('ratio'),
        hasHardcover: $book.data('hardcover'),
        allowZoom: false,
        onStart: function(event, pageObject, corner) {
          self.$container.find('.swiper-container').addClass('overflow');
          self.$container.find('.swiper-slide-prev, .swiper-slide-next').addClass('opacity-0');
        },
        onEnd: function(event, pageObject, corner) {
          self.$container.find('.swiper-container').removeClass('overflow');
          self.$container.find('.swiper-slide-prev, .swiper-slide-next').removeClass('opacity-0');
        },
        onResize: function() {
          if(typeof(self.galleryTop) !== 'undefined') {
            self.galleryTop.updateAutoHeight();
            self.galleryTop.update();           
          }
        },
        /*
        onZoomIn: function() {
          self.$container.find('.swiper-container').addClass('overflow');
          $book.parents('.hero-header').addClass('overflow');
        },
        onZoomOut: function() {
          self.$container.find('.swiper-container').removeClass('overflow');
          $book.parents('.hero-header').removeClass('overflow');
        }
        */
      });


      // Open book if it scrolls into viewport
      let offsetLine = $(window).height() / 3;
      $book.addClass('visibility');
      $book.visibility({
        continuous: false,
        observeChanges: false,
        once: true,
        offset: offsetLine,
        onPassing: function() {
          if($book.turn('page') == 1) {
            setTimeout(function(){
              $book.turn('next');
            }, 500);
          }
        }
      });


      if(typeof(this.galleryTop) !== 'undefined') this.galleryTop.updateAutoHeight();
    },


    /**
     *  Image Viewer
     * 
     */
    initMediaPopup: function() {
      let self = this,
          items = [];

      // Collect data for the popup overlay
      this.$productMediaPlayer.find('.single-media').each(function(index) {
        let src = $(this).data('media-src');

        //if($(this).hasClass('ebook-content') || $(this).hasClass('audio-content')) 
        //  src = $(this).clone();

        let mediaObj = {
          type: $(this).data('media-type'),
          src: src,
        }
        items.push(mediaObj);
      });

      // Init popup
      $('.gallery-top .popup-opener').magnificPopup({
        //delegate: '.popup-open',
        autoFocusLast: false,
        fixedContentPos: false,
        items: items,
        type: 'image',
        mainClass: 'mfp-zoom-out',
        tLoading: '',
        removalDelay: 500, //delay removal by X to allow out-animation
        closeBtnInside: false,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-with-anim">&#215;</button>',
        gallery: {
          enabled: true,
          preload: [0,2],
          arrowMarkup: '<button title="%title%" type="button" class="ui circular large icon button mfp-arrow mfp-arrow-%dir% mfp-with-anim">'+
            '<i class="angle %dir% icon"></i>'+
          '</button>',
        },
        zoom: {
          enabled: false,
          duration: 300, // don't foget to change the duration also in CSS
          opener: function(element) {
            return element.find('img');
          }
        },
        callbacks: {
          imageLoadComplete: function() {
            var self = this;
            setTimeout(function() {
              self.wrap.addClass('mfp-image-loaded');
            }, 16);
          },
          close: function() {
            this.wrap.removeClass('mfp-image-loaded');
          },
          beforeOpen: function() {
            
          },
          open: function() {
            this.goTo($(this.st.el).data('index') - 1);
            self.pauseAllPlayingVideos();
          },
          change: function() {
            if($(this.content).hasClass('ebook-content')) {
              // self.initFlippingBook($(this.content));
              setTimeout(function(){
                $(window).resize();
              }, 1);
            }
          },
          markupParse: function(template, values, item) {
            // Triggers each time when content of popup changes
            console.log('Parsing:', template, values, item);
          },
          buildControls: function() {
            // re-appends controls inside the main container
            //this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
          }
        },
        image: {
          markup: '<div class="mfp-figure mfp-with-anim">'+
                    '<div class="mfp-close"></div>'+
                    '<div class="mfp-img"></div>'+
                    '<div class="mfp-bottom-bar">'+
                      '<div class="mfp-title"></div>'+
                      '<div class="mfp-counter"></div>'+
                    '</div>'+
                  '</div>',
          cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.
          titleSrc: 'title',
          verticalFit: true, // Fits image in area vertically
          tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
        },
        iframe: {
          markup: '<div class="mfp-iframe-scaler mfp-with-anim">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
              id: 'v=', 
              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            }
          },
          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
      });
    },

  });

  return MultimediaPlayer;
})();












/**
 * ------------------------------------------------------------------------------
 *  Cart Playlist
 * ------------------------------------------------------------------------------
 * 
 *
 */
theme.cartPlaylist = {
  $el: $('#cartPlaylistPlayer'),
  playlist: [],
  audioElement: document.querySelector('audio'),
  init: function() {
    const self = this;

    if (self.audioCtx == undefined) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      self.audioCtx = new AudioContext();
    }

    // load some sound
    if (self.source == undefined) {
      self.source = self.audioCtx.createMediaElementSource(self.audioElement);
    }
    
    
    self.currentTrack = document.querySelectorAll('.cart-playlist-action')[0];
    if (self.currentTrack != undefined) {
      const tracks = self.getProductTracks($(self.currentTrack).attr('data-product-id'));
      self.audioElement.setAttribute('src', tracks[0]);
    } else {
      self.$el.addClass('force-hide');
    }

    const playButton = document.querySelector('.controls-play');

    // if track loads
    self.audioElement.addEventListener('loadstart', () => {
      
    }, false);
    
    // if track starts
    self.audioElement.addEventListener('playing', () => {
      
    }, false);

    // if track ends
    self.audioElement.addEventListener('paused', () => {
      
    }, false);

    // if is playing
    self.audioElement.addEventListener('timeupdate', () => {
      $('#cartPlaylistProgress').progress('set percent', (self.audioElement.currentTime / self.audioElement.duration) * 100);
    }, false);

    // if track ends
    self.audioElement.addEventListener('ended', () => {
      playButton.setAttribute( "aria-checked", "false" );
      self.currentTrack.setAttribute( "aria-checked", "false" );
    }, false);
    



    // volume
    const gainNode = self.audioCtx.createGain();
    const volumeControl = document.querySelector('[data-action="volume"]');
    volumeControl.addEventListener('input', function() {
      gainNode.gain.value = this.value;
      localStorage.setItem('volume', this.value);
      //console.log(this.value);
      self.setVolumeIcon(this.value);
    }, false);
    $('.control-toggle-volume-range').on('click', function(e) {
      $('.volume-range-panel').toggleClass('hide');
    });
    $('#sidebarCart').on('click', function(e) {
      if( $(e.target).parent('.volume-range-panel').length == 0 && 
          $(e.target).closest('.control-toggle-volume-range').length == 0 && 
          $('.volume-range-panel').is(":visible") ) {
        $('.volume-range-panel').addClass('hide');        
      }
    });
    if(localStorage.getItem('volume')) {
      gainNode.gain.value = localStorage.getItem('volume');
      volumeControl.value = localStorage.getItem('volume');
      self.setVolumeIcon(localStorage.getItem('volume'));
    }

    // connect our graph
    self.source.connect(gainNode).connect(self.audioCtx.destination);

    self.bindItemEvents();

    $('#cartPlaylistProgress').progress({ percent: 0 });


    self.checkBounds($('.item[data-product-type="audio"]').eq(0).attr('data-product-id'));
    $('.controls-prev').on('click', function(e) {
      const nextTrack = $(self.currentTrack).parents('.item').prevAll('.item[data-product-type="audio"]').first();
      self.checkBounds(nextTrack.attr('data-product-id'));
      self.setCurrentTrack(nextTrack.attr('data-product-id'), true);
    });
    $('.controls-next').on('click', function(e) {
      const nextTrack = $(self.currentTrack).parents('.item').nextAll('.item[data-product-type="audio"]').first();
      self.checkBounds(nextTrack.attr('data-product-id'));
      self.setCurrentTrack(nextTrack.attr('data-product-id'), true);
    });
    
    // play pause audio
    playButton.addEventListener('click', function() {
      
      // check if context is in suspended state (autoplay policy)
      if (self.audioCtx.state === 'suspended') {
        self.audioCtx.resume();
      }
      if (self.audioElement.paused) {
        self.audioElement.play();
        this.setAttribute( "aria-checked", "true" );
        self.currentTrack.setAttribute( "aria-checked", "true" );
      } else {
        self.audioElement.pause();
        this.setAttribute( "aria-checked", "false" );
        self.currentTrack.setAttribute( "aria-checked", "false" );
      }
    }, false);
  },


  // Prev- Next Buttons
  checkBounds(productId) {
    const $list = $('.item[data-product-type="audio"]');
    $('.controls-prev, .controls-next').addClass('disabled');
    if(productId != $list.eq(0).attr('data-product-id'))
      $('.controls-prev').removeClass('disabled');
    if(productId != $list.eq($list.length-1).attr('data-product-id')) 
      $('.controls-next').removeClass('disabled');
  },

  bindItemEvents() {
    const self = this;
    const playButton = document.querySelector('.controls-play');

    $('.cart-playlist-action').off('click').on('click', function(e) {
      console.log($(this).attr('data-product-id'));
      /*
      const tracks = self.getProductTracks($(this).attr('data-product-id'));
      self.currentTrack.setAttribute( "aria-checked", "false" );
      self.currentTrack = $(this)[0];
      if(self.audioElement.getAttribute('src') !== tracks[0]) {
        self.audioElement.setAttribute('src', tracks[0]);
      }
      */

      self.setCurrentTrack($(this).attr('data-product-id'), false);

      // check if context is in suspended state (autoplay policy)
      //if (self.self.audioCtx.state === 'suspended') {
      //  self.self.audioCtx.resume();
      //}
      if (self.audioElement.paused) {
        self.audioElement.play();
        playButton.setAttribute( "aria-checked", "true" );
        this.setAttribute( "aria-checked", "true" );
      } else {
        self.audioElement.pause();
        playButton.setAttribute( "aria-checked", "false" );
        this.setAttribute( "aria-checked", "false" );
      }
      e.preventDefault();
    });
  },

  setCurrentTrack(productId, play) {
    if(theme.cartItemsDetail[productId]) {
      const self = this;
      const playButton = document.querySelector('.controls-play');
      const nextTrack = $(`.item[data-product-id="${productId}"]`);
      const tracks = this.getProductTracks(productId);
      if(self.audioElement.getAttribute('src') !== tracks[0]) {
        self.currentTrack.setAttribute( "aria-checked", "false" );
        self.currentTrack = nextTrack.find('.cart-playlist-action').get(0);
        self.currentTrack.setAttribute( "aria-checked", "true" );
        playButton.setAttribute( "aria-checked", "true" );
        self.audioElement.setAttribute('src', tracks[0]);
        
        if(play) {
          self.audioElement.play();
        }
      }
    }
  },

  getProductTracks(productId) {
    return Object.values(theme.cartItemsDetail[productId].images).map(function(image) {
      if(image.indexOf('.mp3') > 0) {
        let parts = image.split(';');
        return parts[0];
      }    
    });
  },

  resetPlaylist() {
    const self = this;
    if ($('.cart-playlist-action').length != 0) {
      self.currentTrack = document.querySelectorAll('.cart-playlist-action')[0];
      self.audioElement.setAttribute('src', self.currentTrack);
      self.checkBounds($(self.currentTrack).attr('data-product-id'));
      self.bindItemEvents();
      self.$el.transition('fade in');
    } else {
      self.$el.transition('fade out');
    }
  },

  setVolumeIcon(volume) {
    const $icon = $('.control-toggle-volume-range .icon');

    if(volume >= 1) $icon.removeClass('off').removeClass('down').addClass('up');
    else if(volume < 1) $icon.removeClass('off').removeClass('up').addClass('down');
    if(volume == 0) $icon.removeClass('up').removeClass('down').addClass('off');
  }
}
/**
 * Product Quick View Script
 * ------------------------------------------------------------------------------
 *
 * @namespace quickView
 */

theme.QuickView = (function() {

  function QuickView() {
    console.log('QuickView()');

  }

  return QuickView;
})();

/*================ Sections ================*/
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace collectionList
 */

theme.CollectionList = (function() {


  /**
   * CollectionList section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   */
  function CollectionList(container) {

    let $container = $(container);
    let slider = undefined;


    const breakpoint = window.matchMedia( '(min-width:768px)' );
    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {

        if ( slider !== undefined ) {
          slider.destroy( true, true );
          slider = undefined;
        }

        return;
      } else if ( breakpoint.matches === false ) {
        
        slider = new Swiper($container.find('.swiper')[0], {
          threshold: 5,
          initialSlide: 0,
          spaceBetween: 0,
          touchRatio: 0.2,
          slidesPerView: 1,
          centeredSlides: true,
          slideToClickedSlide: true,
          containerModifierClass: 'swiper',
          wrapperClass: 'cards',
          slideClass: 'card'
        });

        return true;
      }
    };
    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);
    // kickstart
    breakpointChecker();
  }

  return CollectionList;
})();
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    quantityMinus: '.product-qty-selector .qty-minus-btn',
    quantityPlus: '.product-qty-selector .qty-plus-btn',
    quantityInput: '.product-qty-selector .product-qty-input'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    //console.log('Product()');

    this.$container = $(container);

    //console.log('###', $(selectors.productJson, this.$container).html(), container);
    //console.log('###', container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var me = this;
    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());


    // Sync. select box changes
    var $selects = $(selectors.singleOptionSelector);
    $selects.change(function(e) {
      var selectId = $(this).attr('id');
      var selectVal = this.value;

      $selects.each(function() {
        if($(this).attr('id') == selectId) {
          $(this).val(selectVal);
        }
      });
    });






    //console.log(this.productSingleObject);

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }


    // Quantity Selector
    this.$container.find(selectors.quantityMinus).prop('disabled', false);
    this.$container.find(selectors.quantityPlus).prop('disabled', false);
    this.$container.find(selectors.quantityInput).prop('disabled', false);
    var quantity = this.$container.find(selectors.quantityInput).attr('value');
    this.$container.find(selectors.quantityMinus).bind('click', function() {
      if(quantity > 1) {
        quantity--;
        me.$container.find(selectors.quantityInput).val(quantity.toString());
      }
      return false;
    });
    this.$container.find(selectors.quantityPlus).bind('click', function() {
      quantity++
      me.$container.find(selectors.quantityInput).val(quantity.toString());
      return false;
    });


    // Add to cart
    this.$container.find('.add-to-cart-btn').bind('click', function() {
      $(this).addClass("loading");
    })
    /*
    $(document).off('cart.requestComplete').on('cart.requestComplete', function(event, cart) {
      alert('vsdvs')
      me.$container.find('.add-to-cart-btn').removeClass("loading");
    });
    */


    // Multimedia Player
    this.player = new theme.MultimediaPlayer({
      $container: this.$container,
      product: this.productSingleObject,
      autoHeight: true,
    });


    // Tabs & Columnize Description text
    var makeColumns = function() {
      $('.description .tab .columnized').columnize({
        width: 500,
        lastNeverTallest: true,
        buildOnce: true
      });
    }
    makeColumns();
    this.$container.find('.description .menu .item').tab({
      'onVisible': function(){
        $('.description .tab .columnized').uncolumnize();
        makeColumns();
        Product.prototype.scrollLayout.calcSticky();
      }
    });
    this.$container.find('#accordion').accordion({
      onOpen: function(){
        //alert('#');
        //Product.prototype.scrollLayout.calcSticky();
      }
    }).on('click', function(e) {
      setTimeout(function() {
        Product.prototype.scrollLayout.calcSticky();
      }, 500);
    });

    //alert(this.$container.find('.accordion').length);


    // Scroll Product Template
    this.scrollLayout.init(this);
    

    //
    //
    // Vegas.js
    var backgroundLists = [];
    this.$container.find('.image-frame').each(function(index, elem) {
      backgroundLists[index] = [];
      $(this).find('a').each(function() {
        var video = null;
        if($(this).data('video-src')) {
          video = {
            src: [$(this).data('video-src')],
            loop: $(this).data('video-loop'),
            mute: $(this).data('video-mute'),
          }
        }
        backgroundLists[index].push({
          src: $(this).attr('href'),
          fade: 2000,
          video: video
        });
      });

      $(this).vegas({
        slides: backgroundLists[index],
        //transition: ['fade', 'zoomOut', 'swirlLeft', 'swirlRight', 'blur'],
        transition: ['zoomOut'],
        animation: 'random',
        timer: false
      });
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Add functionality and resources for the Scroll-Product-Template
     * 
     *
     */
    scrollLayout: {
      $lastTarget: null,
      $singleMedias: null,
      init: function(scope) {
        let self = this;

        this.$singleMedias = scope.$container.find('.single-media');

        // Wenn es kein single content ist
        if(scope.$container.find('.gallery-thumbs img').length > 1) {
          scope.$container.find('.product-media-player').removeClass('single-media');
        }

        // Image loaded Events
        scope.$container.find('.gallery-top img').on('load', function() {
          setTimeout(() => { 
            //self.calcSticky(); 
            $(this).transition({
              animation: 'fade in',
              onComplete : function() {
                self.calcSticky();
              }
            });
            //$('.ui.sticky').sticky('refresh');
          }, 100);
        }).each(function() {
          if(this.complete) $(this).load();
        });

        $(window).resize(() => {
          self.calcSticky();
          scope.$container.find('.gallery-thumbs.ui.sticky').sticky('refresh');
        });

        if($('#context2').length > 0) {
          scope.$container.find('.gallery-thumbs.ui.sticky').sticky({
            debug: false,
            context: '#context2',
            //scrollContext: document,
            observeChanges: true,
            setSize: true,
            offset: -1
          });
        }

        // Vetical Thumbs Click
        $('.vertical-thumbs-container .product-single__thumbnail').bind('click', function() {
          //$('.vertical-thumbs-container .product-single__thumbnail').removeClass('active');
          //$(this).addClass('active');
          
          var index = $(this).index() - 1,
              $targetElem = scope.$container.find('.gallery-top .swiper-slide').eq(index);
          self.scrollToMedia($targetElem);
        });

        // Vetical Thumbs set active thumb 
        let offsetLine = $(window).height() / 3;
        this.$singleMedias.each(function() {
          $(this).visibility({
            silent: true,
            once: false,
            offset: offsetLine,
            onPassing: function() {
              //console.log($(this).parents('.swiper-slide').index());
              let index = $(this).parents('.swiper-slide').index()
              $('.vertical-thumbs-container .product-single__thumbnail').removeClass('active');
              $('.vertical-thumbs-container .product-single__thumbnail').eq(index).addClass('active');
            }
          });
        });

        // Header shrink locking
        $('#shopify-section-product-scroll-template').visibility({
          silent: true,
          once: false,
          onPassing: function() {
            theme.header.headerShrinkLocked = true;
          },
          onBottomPassed: function() {
            theme.header.headerShrinkLocked = false;
          }
        });
      },
      calcSticky: function() {
        let $target = null,
            $rail1 = $('#rail1 .can-sticky'),
            $rail2 = $('#rail2 .can-sticky');

        if($rail1.height() > $rail2.height()) {
          $target = $rail2;
        } else {
          $target = $rail1;
        }

        //this.$singleMedias.visibility('refresh');

        // Prevent double execution
        if(this.$lastTarget && $target.attr('class') == this.$lastTarget.attr('class')) {
          if($target.hasClass('sticky')) {
            $('.ui.sticky').sticky('refresh');
          }
          return false;
        }
        this.$lastTarget = $target;

        $target.addClass('sticky');
        $target.find('.ui.sticky').sticky({
          debug: false,
          context: '#context',
          scrollContext: document,
          observeChanges: true,
          setSize: true,
        });

        $('.ui.sticky').sticky('refresh');
      },
      scrollToMedia: function ($target){
        $('html,body').animate({
          scrollTop: $target.offset().top - $('.fixed-spacer').height()
        }, 'slow');
      }
    },


    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  // Return Product and not Product() in order that the sections.register function is able to
  // invoke Product(). If we would return Product() it would be only triggered once onload and
  // not when the section.register function would do it
  return Product;
})();

/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace featuredProduct
 */

theme.FeaturedProduct = (function() {

  /**
   * FeaturedProduct section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   */
  function FeaturedProduct() {
    console.log('FeaturedProduct()');

  }

  return FeaturedProduct;
})();
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace featuredCollectionSlider
 */

theme.FeaturedCollectionSlider = (function() {

  var selectors = {
    swiperContainer: '.swiper-container',
    collectionCover: '.collection-cover',
    collectionSlider: '[data-featured-collection-slider]',
    settingsJson: '[data-settings-json]'
  };


  /**
   * FeaturedCollectionSlider section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function FeaturedCollectionSlider(container) {
    //console.log('FeaturedCollectionSlider()');

    var self = this;
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    // Section Settings aus Template holen und als Objekt speichern
    this.sectionSettings = JSON.parse($(selectors.settingsJson, this.$container).html());
    //console.log(this.sectionSettings);
    
    var calcSliderBreakpoints = function(bp) {
      var slidesPerView = 1,
          spaceBetween = window.theme.utils.getREM(1.5);

      if(self.sectionSettings.max_row_items == 7 || self.sectionSettings.max_row_items == 8) {
        spaceBetween = window.theme.utils.getEM(11, 1.5);
      }

      if(bp == 320) {
        slidesPerView = 1;

      } else if(bp == 768) {
        slidesPerView = 2;
        if(self.sectionSettings.max_row_items == 7) slidesPerView = 3;
        if(self.sectionSettings.max_row_items == 8) slidesPerView = 3;

      } else if(bp == 991) {
        slidesPerView = Math.round(self.sectionSettings.max_row_items/2)
        if(self.sectionSettings.max_row_items == 4) slidesPerView = 3;
        if(self.sectionSettings.max_row_items == 5) slidesPerView = 3;

      } else if(bp == 1200) {
        slidesPerView = Math.round(self.sectionSettings.max_row_items/1.5)
        if(self.sectionSettings.max_row_items == 4) slidesPerView = 4;
        if(self.sectionSettings.max_row_items == 5) slidesPerView = 4;

      } else {
        slidesPerView = self.sectionSettings.max_row_items

      }

      return {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween
      };
    };

    var swiper = new Swiper('#' + this.$container.parent().attr('id') + ' ' + selectors.swiperContainer, {
      effect: this.sectionSettings.slider_animation_type,
      centeredSlides: this.sectionSettings.slider_centered,
      loop:  this.sectionSettings.slider_loop,
      loopAdditionalSlides: 5,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      slidesPerColumn: 1,
      slidesPerView: this.sectionSettings.max_row_items,
      spaceBetween: (this.sectionSettings.max_row_items == 7 || this.sectionSettings.max_row_items == 8) ? window.theme.utils.getEM(11, 1) : window.theme.utils.getREM(1.5),
      watchOverflow: true,
      setWrapperSize: true,
      //preloadImages: false,
      //lazy: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is <= 320px
        320: calcSliderBreakpoints(320),
        // when window width is <= 768px
        768: calcSliderBreakpoints(768),
        // when window width is <= 991px
        991: calcSliderBreakpoints(991),
        // when window width is <= 1200px
        1200: calcSliderBreakpoints(1200)
      }
    });


    //console.log(window.theme.utils.getREM(1));


    var opacity = 1;
    swiper.on('sliderMove', function(e, progress, direction) { 
      //console.log(progress.movementX)
      if(e.activeIndex == 0 || e.activeIndex == 1) {
        opacity += progress.movementX/10;
        if(opacity < 0) opacity = 0;
        if(opacity > 1) opacity = 1;
        self.$container.find(selectors.collectionCover).css({opacity: opacity});
        //console.log(opacity);
      }

      // Instantclick - Swipe-klick Problem
      $(selectors.swiperContainer).find('.card').attr('data-no-instant', '');
    });

    // Instantclick - Swipe-klick Problem
    swiper.on('touchEnd', function() {  
      setTimeout(function() {
        $(selectors.swiperContainer).find('.card').removeAttr('data-no-instant');
      }, 100);
    });

    // FIX: Breakpoints on Mobile not working
    setTimeout(function() {
      swiper.update();
    }, 100);
  }



  FeaturedCollectionSlider.prototype = $.extend({}, FeaturedCollectionSlider.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      //this.$container.off(this.namespace);
      //alert('section:unload');
    },
    onLoad: function() {
      //alert('section:load');
    },
    onSelect: function() {
      //alert('section:select');
    }
  });

  return FeaturedCollectionSlider;
})();
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace slideshow
 */

theme.Slideshow = (function() {

  var selectors = {
    swiperContainer: '.section-slideshow .slideshow.swiper-container',
    swiperWrapper: '.swiper-wrapper'
  }

  /**
   * Slideshow section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   */
  function Slideshow(container) {
    //console.log('Slideshow()');
    var self = this;
    var $slideshow = $(selectors.swiperContainer);
    this.$container = $(container);
    this.isAutoplaying = false;
    this.vegasInitialized = false;
    this.currentSlideIndex = 0;
    this.currentVegasGallery = null;

    $('.site-header').addClass('is-light');

    // Exit code if Slider has no slides
    if($slideshow.find('.swiper-slide').length === 0) {
      return;
    }


    // Init Videoplayer
    this.players = null;
    this.activePlayerIndex = null;
    this.lastSlideIndex = -1;
    var calculateZoomFactor = function() {
      var videoRatio = 16 / 9,
          gridRatio = $slideshow.find('.video-bg-content').width() / $slideshow.find('.video-bg-content').height(),
          ratio1 = videoRatio/gridRatio,
          scaleFactor = (ratio1 > 1) ? ratio1 : 1;
      //console.log(videoRatio/gridRatio, gridRatio/videoRatio);
      $slideshow.find('.plyr__video-wrapper.plyr__video-embed')
        .attr('style', 'transform: scale('+ scaleFactor +')')
    }
    if($slideshow.find('.video-bg-content').length > 0) {
      this.players = Plyr.setup('.video-bg-player', {
        muted: true,
        clickToPlay: false,
        controls: [],
        autoplay: false,
        hideControls: true
      });
      $(window).on('resize', calculateZoomFactor);
      calculateZoomFactor();
      // Indexe als data attr speichern
      $slideshow.find('.video-bg-content').each(function(index) {
        $(this).data('player-index', index);
      });
          
      this.players[0].on('playing', event => {
        if($('.video-bg-content .cover').transition('is visible')) {
          $('.video-bg-content .cover').transition('fade out');
        }
      });
      this.players[0].on('ended', event => {
        $('.video-bg-content .cover').transition('fade in');
      });
    }

    // Vegas.js initialisieren
    var initImageBg = function(scope) {
      var backgroundLists = [];
      $slideshow.find('.image-frame').each(function(index, elem) {
        backgroundLists[index] = [];
        $(this).find('a').each(function() {
          var video = null;
          if($(this).data('video-src')) {
            video = {
              src: [$(this).data('video-src')],
              loop: $(this).data('video-loop'),
              mute: $(this).data('video-mute'),
            }
          }
          backgroundLists[index].push({
            src: decodeURI($(this).attr('href')),
            video: video
          });
        });

        $(this).vegas({
          slide: backgroundLists[index].length - 1,
          transition: [ 'zoomOut' ],
          slidesToKeep: 1,
          slides: backgroundLists[index],
          transitionDuration: 1000,
          delay: 3000,
          animation: 'random',
          timer: true,
          loop: true,
          preload: true,
          //preloadImage: false,
          //preloadVideo: false,
          autoplay: false,
          walk: function (slideIndex, slideSettings) {
            if(slideIndex == backgroundLists[index].length - 1) {
              $(this).vegas('pause');
            }
          }
        }).vegas('pause');
      });
      scope.vegasInitialized = true;
    }


    // Slideshow initialisation
    this.slideshow = new Swiper (selectors.swiperContainer, {
      init: false,
      loop: $slideshow.data('loop'), //$slideshow.find('.swiper-slide').length > 1 ? true : false,
      spaceBetween: 0,
      parallax: false,
      effect: $slideshow.data('effect'),
        slideShadows: false,
      coverflowEffect: {
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.slider-button-next',
        prevEl: '.slider-button-prev',
      },
      keyboard: {
        enabled: true
      },
      on: {
        touchMove: function() {
          self.isAutoplaying = false;
        }
      }
    });

    this.slideshow.on('init', function() { 
      initImageBg(self);

      var $currentSlide = $slideshow.find('.swiper-slide-active');
      $currentSlide.find('.anim-container').transition({
        animation: 'scale in',
        duration: 1000,
      });   
      $currentSlide.find('.image-frame').vegas('play');
    });

    
    // Initial und bei jedem slide prüfen, ob in dem Slide Block die Variable is-light gechecked ist
    // und gegebenenfalls die is-light Klasse dem Header hinzufügen bzw entfernen.
    this.slideshow.on('transitionStart', function (e) {
      var $currentSlide = $slideshow.find('.swiper-slide-active');
      //console.log('transitionStart', this.realIndex);

      if($currentSlide.hasClass('is-light')) {
        $('.site-header').addClass('is-light');
      } else {
        $('.site-header').removeClass('is-light');
      }
    });


    this.slideshow.on('transitionEnd', function (e) {
      var $currentSlide = $slideshow.find('.swiper-slide-active');
      //console.log('transitionEnd', this.realIndex);

      // Images Player stoppen/replayen
      if(self.vegasInitialized) {
        $currentSlide.find('.image-frame').vegas('play');
      }

      // Content/text animation
      if(self.lastSlideIndex != self.slideshow.realIndex || $slideshow.data('loop') === 'false') {
        $slideshow.find('.swiper-slide:not(.swiper-slide-active)').find('.anim-container').transition('hide');
        if(!$currentSlide.find('.anim-container').transition('is visible')) {
          $currentSlide.find('.anim-container').transition({
            animation: 'scale in',
            duration: 1000,
          });      
        }
      } else {
        $currentSlide.find('.anim-container').transition('show'); 
      }

      // Video stoppen/replayen
      var playerIndex = $currentSlide.find('.video-bg-content').data('player-index');
      if(self.activePlayerIndex !== null && self.players[self.activePlayerIndex].playing) {
        if(self.slideshow.realIndex != self.lastSlideIndex) {
          self.players[self.activePlayerIndex].pause();
          self.players[self.activePlayerIndex].rewind();
        }
      }
      if(Number.isInteger(playerIndex)) {
        calculateZoomFactor();
        self.activePlayerIndex = playerIndex;
        self.players[playerIndex].play();
      }

      self.lastSlideIndex = self.slideshow.realIndex;
      self.currentSlideIndex = this.realIndex;
    });

    this.slideshow.init();


    // Autoplay nur dann laufen lassen, wenn slider auch im viewport ist
    $slideshow.visibility({
      continuous: false,
      observeChanges: true,
      once: false,
      onPassing: function() {
        if(self.isAutoplaying) {
          self.slideshow.autoplay.start();
        }
      },
      onBottomPassed: function() {
        if(self.isAutoplaying) {
          self.slideshow.autoplay.stop();
        }
      }
    });

    // Product Slide
    $('.show-product-form-btn').bind('click', function() {
      $('.product-form-container').transition({
        animation: 'fade up in',
        duration: '.3s'
      });
    });
    $('.close-product-form-btn').bind('click', function() {
      $('.product-form-container').transition({
        animation: 'fade up out',
        duration: '.3s'
      });
    });

    // Hide prev- next buttons when mouse not moving or not over
    var $buttons = $('.slider-button-prev .transition, .slider-button-next .transition'),
        i = null;
    $slideshow.mousemove(function() {
      clearTimeout(i);
      $buttons.removeClass('out').addClass('in');
      i = setTimeout(function () {
        $buttons.removeClass('in').addClass('out');
      }, 3000);
    }).mouseleave(function() {
      clearTimeout(i);
      $buttons.removeClass('in').addClass('out');
    });

    // Scroll to section button
    $('.next-section-btn').click(function (){
      var delay = theme.header.$siteHeader.hasClass('is-expanded') ? 500 : 0;
      theme.header.shrink();

      setTimeout(() => {
        $('html, body').animate({
          scrollTop: $('.shopify-section:eq(2)').offset().top - $('#siteHeader').height()
        }, 1000);
      }, delay);
    });
  }


  Slideshow.prototype = $.extend({}, Slideshow.prototype, {

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      this.slideshow.off('init transitionStart transitionEnd');
    },

    /**
     * Event callback for Theme Editor `block:select` event
     */
    onSelect: function() {
      
    },

    /**
     * Event callback for Theme Editor `block:select` event
     */
    onBlockSelect: function(e) {
      this.slideshow.slideTo($(e.target).index());
    }
  });

  return Slideshow;
})();
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace imageRow
 */

theme.ImageRow = (function() {

  /**
   * ImageRow section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   */
  function ImageRow(container) {
    //console.log('ImageRow()');

    let self = this,
        $container = $(container),
        $sectionElement = $container.parent('#shopify-section-image-row-page');
        
    this.sectionSettings = JSON.parse($('[data-settings-json]', $container).html());

    // Negate footer margin-top if this is the last section in the list
    if($container.parent().index() + 1 === $container.parent().parent().children().length) {
      $('#MainContent').addClass('no-footer-padding');
    }
    // alert($sectionElement.prev().attr('id'));
    if($sectionElement.prev().attr('id') === 'shopify-section-product-scroll-template') {
      $container.find('.section-spacer').remove();
    }

    // Background Image Gallery
    var backgroundList = [];
    $container.find('.image-frame a').each(function() {
      backgroundList.push({
        src: $(this).attr('href')
      });
    });
    $container.find('.image-frame').vegas({
      slides: backgroundList,
      transitionDuration: 2000,
      //transition: [ 'fade', 'zoomOut', 'swirlLeft', 'swirlRight', 'blur' ],
      transition: [ 'zoomOut' ],
      animation: 'random',
      timer: false,
      loop: true,
      preload: true,
      walk: function(index) {
        if(!self.sectionSettings.loop_images && index == backgroundList.length - 1) {
          $(this).vegas('pause');
        }
      }
    });
    $container.find('.image-frame').vegas('pause');

    // Play Background Gallery on scroll
    $container.visibility({
      continuous: false,
      observeChanges: true,
      once: false,
      onOnScreen: function() {
        $container.find('.image-frame').vegas('play');
      },
      onOffScreen: function() {
        $container.find('.image-frame').vegas('pause');
      }
    });
  }

  return ImageRow;
})();
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace mediaContent
 */

theme.MediaContent = (function() {

  /**
   * MediaContent section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   */
  function MediaContent(container) {
    //console.log('MediaContent()');

    var $container = $(container);

    // Negate footer margin-top if this is the last section in the list
    if($container.parent().index() + 1 === $container.parent().parent().children().length) {
      $('#MainContent').addClass('no-footer-padding');
    }

    // Background Image Gallery
    var backgroundList = [];
    $container.find('.image-frame a').each(function() {
      backgroundList.push({
        src: $(this).attr('href'),
        fade: 2000,
      });
    });
    $container.find('.image-frame').vegas({
      slides: backgroundList,
      transitionDuration: 2000,
      transition: [ 'fade', 'zoomOut', 'swirlLeft', 'swirlRight', 'blur' ],
      animation: 'random',
      timer: false,
      loop: false,
      preload: true
    });
    $container.find('.image-frame').vegas('pause');

    // Multimedia Player
    this.player = new theme.MultimediaPlayer({
      $container: $container,
      autoHeight: true,
    });
  }

  return MediaContent;
})();
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace scrollStory
 */

theme.ScrollStory = (function() {

  var selectors = {
    scrollStory: '[data-parallax-content]'
  };


  /**
   * FeaturedCollectionSlider section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function ScrollStory(container) {
    //console.log('ScrollStory()');


    var $container = $(container);
    var $scrollStory = $(selectors.scrollStory);




    // Negate footer margin-top if this is the last section in the list
    if($container.parent().index() + 1 === $container.parent().parent().children().length) {
      $container.addClass('negate-footer-margin');
    }




    // init ScrollMagic Controller
    var controller = new ScrollMagic.Controller();

    // Scene Handler
    var duration0 = 0;
    //$('.section-scroll-story section').each(() => { duration0 += $(this).height() });
    var scene0 = new ScrollMagic.Scene({
      triggerElement: "#pinned-trigger0", // point of execution
      //duration: 400, // pin the element for a total of 400px
      //duration: duration0 - 500, // pin element for the window height - 1
      triggerHook: 0, // don't trigger until #pinned-trigger1 hits the top of the viewport
      reverse: true // allows the effect to trigger when scrolled in the reverse direction
    })
    .setPin("#pinned-element0"); // the element we want to pin

    // Scene Handler
    var scene1 = new ScrollMagic.Scene({
      triggerElement: "#pinned-trigger1", // point of execution
      duration: $(window).height() - 100, // pin element for the window height - 1
      triggerHook: 0, // don't trigger until #pinned-trigger1 hits the top of the viewport
      reverse: true // allows the effect to trigger when scrolled in the reverse direction
    })
    .setPin("#pinned-element1"); // the element we want to pin

    // Scene2 Handler
    var scene2 = new ScrollMagic.Scene({
      triggerElement: "#pinned-trigger2", // point of execution
      duration: 400 // pin the element for a total of 400px
    })
    .setPin("#pinned-element2"); // the element we want to pin

    // Add Scenes to ScrollMagic Controller
    controller.addScene([
      scene0,
      scene1,
      scene2
    ]);



    /*
    var $scrollStory = $('.section-scroll-story');
    var $scrollStoryStage = $('.section-scroll-story .stage');

    $scrollStoryStage.height($( window ).height());
    $scrollStory.height($scrollStoryStage.height() * 3);

    setTimeout(function(){

      $scrollStoryStage.waypoint(function(direction) {
        if(direction == 'down') $scrollStoryStage.addClass('fixed-top');
        if(direction == 'up') $scrollStoryStage.removeClass('fixed-top');
        //console.log('top - ' + direction);
      }, { 
        group: 'custom-group'
      })
    }, 100);

    $scrollStory.waypoint(function(direction) {
      if(direction == 'down') $scrollStoryStage.removeClass('fixed-top').addClass('absolute-bottom');
      if(direction == 'up') $scrollStoryStage.removeClass('absolute-bottom').addClass('fixed-top');
      //console.log('bottom - ' + direction);
    }, { 
      group: 'custom-group',
      offset: 'bottom-in-view'
    });
    */

  }


  return ScrollStory;
})();
/**
 * Featured Collection Slider Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the 
 * Featured Collection Slider Section
 *
 * @namespace instagramFeed
 */

theme.InstagramFeed = (function() {

  var selectors = {
    swiperContainer: '.swiper-container',
    settingsJson: '[data-settings-json]'
  };

  /**
   * InstagramFeed section constructor. Runs on page load
   * as well as Theme Editor `section:load` events.
   */
  function InstagramFeed(container) {
    //console.log('InstagramFeed()');

    var self = this;
    this.$container = $(container);

    // Section Settings aus Template holen und als Objekt speichern
    this.sectionSettings = JSON.parse($(selectors.settingsJson, this.$container).html());
    //console.log(this.sectionSettings);

    // Slider
    var swiper = new Swiper('#' + this.$container.parent().attr('id') + ' ' + selectors.swiperContainer, {
      //init: false,
      //centeredSlides: true,
      //loop: true,
      //loopAdditionalSlides: 5,
      slidesPerView: this.sectionSettings.max_row_items,
      spaceBetween: window.theme.utils.getREM(1.5),
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is <= 768px
        768: {
          slidesPerView: 3,
          spaceBetween: window.theme.utils.getREM(0.75)
        },
        // when window width is <= 991px
        991: {
          slidesPerView: Math.round(self.sectionSettings.max_row_items/2),
          spaceBetween: window.theme.utils.getREM(2)
        },
        // when window width is <= 1200px
        1200: {
          slidesPerView: self.sectionSettings.max_row_items,
          spaceBetween: window.theme.utils.getREM(1.5)
        }
      }
    });


    // Overlayer
    self.$container.find('.card .image').dimmer({
      on: 'hover'
    });

    var attachScrollAnimation = function() {

      self.$container.find('.scroll-animate-section').visibility({
        continuous: false,
        observeChanges: true,
        once: true,
        offset: -100,
        onOnScreen: function() {
          // WORKAROUND: Initial Height
          //var tmpMinHeight = self.$container.find('.swiper-slide.spacer').height();
          //self.$container.find('.cards').attr('style', 'min-height:'+ tmpMinHeight +'px');
          swiper.removeSlide(0);
          swiper.update();

          self.$container.find('.cards .card')
            .transition('clear queue')
            .transition({
              animation : 'scale in',
              duration  : 1000,
              interval  : 200
            }); 
          
          // WORKAROUND: Initial Height
          setTimeout(function() {
            self.$container.find('.cards').attr('style', '');
          }, 1000);

          // Overlayer
          self.$container.find('.card .image').dimmer({
            on: 'hover'
          });
        }
      });
    }

    // Instagram Feed
    var trans = window.theme.settings.useScrollAnimation ? ' transition hidden' : '';
    var feed = new Instafeed({
      //get: 'tagged',
      //tagName: 'Domrep',
      get: 'user',
      userId: this.sectionSettings.insta_user_id,
      accessToken: this.sectionSettings.insta_access_token,
      sortBy: this.sectionSettings.insta_sort_by,
      limit: this.sectionSettings.maxitems,
      resolution: 'low_resolution',
      template: 
        '<div class="swiper-slide" data-swiper-autoplay="3000">'+
          '<div class="ui card'+ trans +'">'+
            '<a href="{{link}}" target="_blank">'+
              '<div class="ui masked image">'+
                '<img src="{{image}}" alt="{{caption}}" />'+
                '<div class="ui dimmer">'+
                  '<div class="content">'+
                    '<div class="center">'+
                      '<p>{{caption}}</p>'+
                      '<p><i class="instagram big icon"></i></p>'+
                      '<p><small><i class="heart icon"></i> {{likes}} <span class="hide-mobile">likes</span>,  <i class="comments icon"></i> {{comments}} <span class="hide-mobile">comments</span></small></p>'+
                    '</div>'+
                  '</div>'+
                '</div>'+
              '</div>'+
            '</a>'+
          '</div>'+
        '</div>',
      target: 'instafeed',
      after: function() {
        var items = $('#instafeed .swiper-slide').toArray();
        swiper.addSlide(1, items);

        attachScrollAnimation();
      }
    });
    if(this.sectionSettings.insta_access_token != '') { 
      feed.run();    
    } else {
      attachScrollAnimation();
    }
  }

  return InstagramFeed;
})();

/*================ Templates ================*/
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

//theme.password = (function() {
theme.password = function() {
  var config = {
    passwordTemplate: '.template-password'
  };

  if (!$(config.passwordTemplate).length) {
    return;
  }

  if(location.hash.substr(1) === 'login') {
    $('#login').removeClass('hide');
    $('#showLoginBtn').addClass('hide');
  }


  $('#showLoginBtn').bind('click',  function(){
    $('#login').removeClass('hide');
    $(this).addClass('hide');

    event.stopPropagation();
  });
  $('#goBackBtn').bind('click',  function(){
      $('#login').addClass('hide');
      $('#showLoginBtn').removeClass('hide');
  });
  $(window).bind('click',  function(){
    if(!$('#login').hasClass('hide') && !$(event.target).parents("#login").is("#login")) {
      $('#login').addClass('hide');
      $('#showLoginBtn').removeClass('hide');
    }
  });



  // Background Image Gallery
  var backgroundList = [];
  $('.image-frame a').each(function() {
    backgroundList.push({
      src: $(this).attr('href')
    });
  });
  $('.image-frame').vegas({
    slides: backgroundList,
    transitionDuration: 4000,
    transition: [ 'fade', 'zoomOut', 'swirlLeft', 'swirlRight' ],
    animation: 'random',
    timer: false,
    loop: true,
    preload: true,
  }).vegas('play');
};
//})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

//theme.customerAddresses = (function() {
theme.collections = function() {
  

  let $container = $('.page-hero-header');

  // Background Image Gallery
  var backgroundList = [];
  $container.find('.image-frame a').each(function() {
    backgroundList.push({
      src: $(this).attr('href')
    });
  });
  $container.find('.image-frame').vegas({
    slides: backgroundList,
    transitionDuration: 2000,
    //transition: [ 'fade', 'zoomOut', 'swirlLeft', 'swirlRight', 'blur' ],
    transition: [ 'zoomOut' ],
    animation: 'random',
    timer: false,
    loop: false,
    preload: true,
    end: function() {
      //$container.find('.image-frame').vegas('pause');
    }
  });
  $container.find('.image-frame').vegas('pause');
};
//})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

//theme.customerAddresses = (function() {
theme.customerAddresses = function() {
  var $newAddressForm = $('#AddressNewForm');


  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify.CountryProvinceSelector) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('#Address_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
};
//})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
};



theme.initTheme = function() {
  if(typeof sections === 'undefined') {
    var sections = new slate.Sections();
  }

  // Section Registration
  sections.register('collection-list', theme.CollectionList);
  sections.register('product', theme.Product);
  sections.register('featured-product', theme.Product);
  sections.register('featured-collection-slider', theme.FeaturedCollectionSlider);
  sections.register('slideshow', theme.Slideshow);
  sections.register('image-row', theme.ImageRow);
  sections.register('media-content', theme.MediaContent);
  sections.register('scroll-story', theme.ScrollStory);
  sections.register('instagram-feed', theme.InstagramFeed);

  // Templates
  theme.customerLogin();
  theme.customerAddresses();
  theme.password();
  theme.collections();

  // Modules
  theme.initLayout();
  theme.header.init();
  theme.ajaxCart.init();
  theme.initGoogleMaps();
  theme.initSlateStuff();
  theme.initLangifySupport();
  theme.initGeolizrSupport();

  if(theme.mediaPlayer.useCartPlaylist) {
    theme.cartPlaylist.init();
  }
}



theme.initThemeApp = function() {
  let sections = new slate.Sections(),
      errorOccured = false
      nextUrl = '';

  // InstantClick 
  InstantClick.on('beforeunload', function() {
    //console.log('beforeunload');

    // Error fallback
    if(errorOccured && nextUrl !== '') {
      //alert(nextUrl);
      window.location.href = nextUrl;
    }    

    // Page Transitions
    var $pageTransitioner = $('#pageTransitioner');
    if($pageTransitioner.length > 0) {
      //InstantClick.freeze();

      // WORKAROUND: Mobile loading bug
      if(!theme.utils.isMobileOrTabletDevice()) {
        $pageTransitioner.addClass('active');
        $pageTransitioner.find('.layer').transition({
          animation  : $pageTransitioner.data('transition-type') + ' in',
          duration   : '.5s',
          onComplete : function() {
            //InstantClick.unfreeze();
          }
        });
      }
    }

    // FIX: Slideshow & header is-light bug
    if($('.swiper-container').length) {
      var mySwiper = document.querySelector('.swiper-container').swiper;
      if(mySwiper) {
        mySwiper.off('transitionStart');
      }
    }
    // FIX: Parallax Ruckel Bug
    //$(window).off('load scroll resize');    
  });

  InstantClick.on('fetch', function() {
    //console.log('fetch');
  });

  InstantClick.on('wait', function() {
    //console.log('wait');
  });

  InstantClick.on('receive', function(url, body, title) {
    //console.log('receive');
    nextUrl = url;
  });

  InstantClick.on('change', function(isInitialLoad) {
    //console.log('change', location.pathname);
    
    setTimeout(function() {
      theme.initTheme();
    }, 100);
  });

  //InstantClick.init();
  InstantClick.init('mousedown');

  /*
  // Error fallback
  window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
    //alert("Error occured: " + errorMsg);//or any message
    errorOccured = true;
    return false;
  }
  $(document).ready(function() {
    $('a').bind('mouseover', function() {
      var attr = $(this).attr('href');
      if (typeof attr !== typeof undefined && attr !== false) {
        nextUrl = $(this).attr('href');
        console.log(nextUrl);
      }
    });
  });
  */
}







theme.initLayout = function() {
  var self = this;

  // Tilt.js
  var tilt = $('[data-tilt]').tilt();

  // Parallax
  $('.parallax').parallax();


  $('.add-to-cart-btn').click(function( event ) {
    //event.stopPropagation();
    $(this).addClass('loading');

    let dataPlaylistJson = $('[data-playlist-json]', $(this).parents('.product-grid-item')).html();
    if(dataPlaylistJson !== '[]') {
      let dataPlaylist = JSON.parse(dataPlaylistJson);

      theme.cartItemsDetail[$(this).data('cart-add')] = {
        type: "audio",
        images: dataPlaylist
      }
    }
  });

  // ========== Page Transitions ==========
  var $pageTransitioner = $('#pageTransitioner');
  if($pageTransitioner.length > 0) {
    $pageTransitioner.find('.layer').transition({
      animation  : $pageTransitioner.data('transition-type') + ' out',
      duration   : '.5s',
      onComplete : function() {
        $pageTransitioner.removeClass('active').removeClass('initial');
      }
    });
    if(!theme.settings.instantMode) {
      $(window).on('beforeunload', function() {
        $pageTransitioner.addClass('active');
        $pageTransitioner.find('.layer').transition({
          animation  : $pageTransitioner.data('transition-type') + ' in',
          duration   : '.5s'
        }); 
      });
    }
  }

  // ========== Text Animations ==========
  $('.text-animate').each(function() {
    var $textElem = $(this);
    $textElem.textillate({
      autoStart: false,
      in: { effect: theme.settings.inAnimationType },
      out: { effect: theme.settings.outAnimationType },
    });
    if($textElem.parents('.scroll-animate').length == 0) {
      $textElem.textillate('in');
    }
  });
  $('.section-title-animate').each(function() {
    var $textElem = $(this);
    $textElem.textillate({
      autoStart: false,
      in: { effect: theme.settings.inAnimationType },
      out: { effect: theme.settings.outAnimationType },
    });
    setTimeout(function() {
      $textElem.visibility({
        continuous: false,
        observeChanges: true,
        once: true,
        offset: 0,
        onBottomVisible: function() {
          $textElem.textillate('in');
          //this.destroy();
        }
      });
    }, 100);
  });

  // ========== Scroll Animations ==========
  theme.utils.metrics.lastScrollTop = $(window).scrollTop();
  $(window).unbind('scroll').scroll(function(event){
    var st = $(this).scrollTop();
    //console.log('---', st, theme.utils.metrics.lastScrollTop)
    if (st == theme.utils.metrics.lastScrollTop) theme.utils.metrics.scrollDir = 'none';
    else if (st > theme.utils.metrics.lastScrollTop) theme.utils.metrics.scrollDir = 'down';
    else theme.utils.metrics.scrollDir = 'up';
    theme.utils.metrics.lastScrollTop = st;
  });

  $('.scroll-animate').visibility({
    continuous: false,
    observeChanges: true,
    once: true,
    offset: -100,
    onOnScreen: function() {
    //onPassing: function() {
      var me = this;
      var animation = 'scale';

      /*
      if($(this).data('animation') == 'scale') {
        animation = 'scale';
      } else {
        // Fade Animation mit theme.utils.metrics.scrollDirection
        var direction = ($(this).data('direction') != undefined) ? $(this).data('direction') : 'up';
        if(direction == 'up' && theme.utils.metrics.scrollDir == 'up') direction = 'down';
        animation = 'fade ' + direction + ' in';
      }
      */

      if(!$(me).data('transition-added')) {
        $(me).data('transition-added', true);
        $(me).transition({
          animation: animation,
          duration: $(this).data('animation-duration') ? $(this).data('animation-duration') : 1000,
          offset: $(this).data('animation-offset') ? $(this).data('animation-offset') : 500,
          onStart: function() {
            $(me).find('.text-animate').textillate('in');
          },
          onShow: function() {
            // Alle Visibilitys refreshen
            $('.scroll-animate, .scroll-animate-sequence, .scroll-animate-section, .visibility').visibility('refresh');
          }
        });
      }
    }
  });

  // Sequence (scrolling) Animations
  var animateSequence = function($container) {
    //if(!$container.find('.cards .card').transition('is visible') || !$container.find('.cards .card').transition('is animating')) {
    if(!$container.data('transition-added')) {
      $container.data('transition-added', true);
    
      $container.find('.cards .card')
        .transition('clear queue')
        .transition({
          allowRepeats: true, // TEST 
          animation : $container.data('animation') ? $container.data('animation') : 'scale in',
          duration  : 800,
          interval  : 200,
          onShow    : function() {
            // Visible attribute auf container hinzufügen
            //$container.find('.cards').attr('data-is-visible', true);

            // Alle Visibilitys refreshen
            $('.scroll-animate, .scroll-animate-sequence, .scroll-animate-section, .visibility').visibility('refresh');

            // Lazyload Images
            // Bei Sequenzanimationen, Lazyloading erst hier starten, da es sonst flackert
            $(this).find('img').addClass('lazyload');
          }
        })
      ;  
    }
  };

  $('.scroll-animate-sequence').visibility({
    //type: 'image',
    continuous: false,
    observeChanges: true,
    once: true,
    offset: -100,
    onOnScreen: function() {
      animateSequence($(this));
    },
    onPassing: function() {
      animateSequence($(this));
    }
  });


  // ========== Sidebar ==========
  var $window = $(window);
  var $sidebarMenu = $('#sidebarMenu');
  var sidebarResize = function() {
    if($window.width() < 480) {
      $('#sidebarMenu, #sidebarPusher, #sidebarCart').removeClass('wide');
    } else {
      $('#sidebarMenu, #sidebarPusher, #sidebarCart').addClass('wide');
    }
  }
  sidebarResize();
  $window.resize(sidebarResize);
  $sidebarMenu.sidebar({
    exclusive: false,
    scrollLock: true,
    onShow: () => {
      $sidebarMenu.find('.sidebar-content').transition('fade right in');
    },
    onHide: () => {
      $sidebarMenu.find('.sidebar-content').transition('fade out');
    }
  })
  .sidebar('attach events', '.toc.item', 'show');


  // ========== Footer ==========
  var $footer = $('footer');
  var $mainContent = $('#MainContent');
  var footerResize = function() {
    if($window.width() < 768) {
      $footer.removeClass('fixed');
      $mainContent.css({marginBottom: 0});
    } else {
      $footer.addClass('fixed');
      $mainContent.css({marginBottom: $footer.height()});
    }
    if($mainContent.height() + $footer.height() < $window.height()) {
      $mainContent.removeClass('shadowed');
    } else {
      $mainContent.addClass('shadowed');
    }
  }
  if(window.theme.footer.isFixed && !window.theme.utils.isChrome) {
    $window.resize(footerResize);
    footerResize();
  } else {
    $footer.removeClass('fixed');
    if(window.theme.footer.isFixed) {
      $mainContent.addClass('shadowed');
      $('#shopify-section-footer').css({ zIndex: -1 });
    }
  }

  // ========== Semantic UI ==========
  $('.ui.dropdown').dropdown({ transition: 'drop' });
  $('.ui.accordion').accordion();

  // ========== Grid Items ==========
  if(window.theme.gridItems.informationOverlaying) {
    $('.product-grid-item .image').dimmer({
      on: 'hover'
    });
  }

  // ========== Sort By Filter ==========
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('#sort-by')
    .dropdown('set value', window.theme.collection.sortBy)
    .dropdown({
      on: 'click',
      onChange: function(value, text, $choice) {
        Shopify.queryParams.sort_by = value;
        location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
      }
    })

  // ========== Product Tag Filters ==========
  let currentFilter = window.location.pathname.replace( '/collections/' + window.theme.collection.filterBy + '/', '' );
  let $collFilters = $('#filter-by');
  $collFilters
    .dropdown('set value', currentFilter)
    .dropdown({
      on: 'click',
      onChange: function(value, text, $choice) {
        var newTags = [];
        $collFilters.each(function() {
          if (value) {
            newTags.push(value);
          }
        });
        if (newTags.length) {
          var query = newTags.join('+');
          window.location.href = $(window.theme.collection.tag).attr('href').replace('/' + 'tag', '/' + query);
        }
        else {
          window.location.href = window.theme.collection.tag;
        }
      }
    });

  // ========== Lazy Loading ==========
  /*
  $(document).on('lazybeforesizes', function(e){
    //use width of parent node instead of the image width itself
    e.detail.width = $(e.target).closest('.image-container').innerWidth() || e.detail.width;
    console.log(e.detail.width);
  });
  */
}



// ========== Header ==========
theme.header = {
  headerLocked: false,
  headerShrinkLocked: false,
  headerWasTransparent: false,
  headerWasExpanded: false,
  $siteHeader: null,
  shrinkPoint: 100,

  init: function() {
    var self = this;

    self.$siteHeader = $('#siteHeader');

    self.$siteHeader.off('resize').on('resize', self.resize);
    self.resize();
    
    // Megamenu
    $('.main-menu .ui.dropdown').dropdown({
      on: 'hover',
      transition: 'scale'
    });
    $('.main-menu .ui.mega-dropdown').hover(function() {
      var $target = $(this).find('.megamenu');
      $target.transition('clear queue').transition('scale in', function() {
        self.shrink();
        self.headerLocked = true;
      });
    }, function() {
      var $target = $(this).find('.megamenu');
      $target.transition('clear queue').transition('hide');
      if (theme.utils.metrics.lastScrollTop == 0) {
        self.$siteHeader.off('mouseleave').on('mouseleave', function() {
          self.headerLocked = false;
          if (theme.utils.metrics.lastScrollTop == 0) {
            self.expand();
          }
        });
      } else {
        self.headerLocked = false;
      }
    });

    // fix menu when passed
    $('.masthead').visibility({
      once: false,
      offset: 10,
      onBottomPassed: function() {
        $('.fixed.menu').transition('fade in');
      },
      onBottomPassedReverse: function() {
        $('.fixed.menu').transition('fade out');
      }
    });

    $('#MainContent').visibility({
      once: false,
      offset: -1,
      continuous: false,
      onTopPassed: function() {
        self.shrink();
      },
      onTopVisible: function() {
        self.expand();
      },
      onUpdate: function(calculations) {
        if(theme.utils.metrics.scrollDir !== 'none') {
          if(!self.headerShrinkLocked) {
            $('#searchPanel').accordion('close', 0);  
            if(window.theme.settings.header.shrinkableHeaderAllowed && !self.headerLocked) {
              if(calculations.pixelsPassed > self.shrinkPoint) {
                self.$siteHeader.addClass('is-shrinked');
              } else {
                self.$siteHeader.removeClass('is-shrinked');
              }
            }
            if(window.theme.settings.header.hideableHeaderAllowed && !self.headerLocked) {
              if(calculations.pixelsPassed > 2500) {
                self.$siteHeader.addClass('is-hidden');
              } else {
                self.$siteHeader.removeClass('is-hidden');
              }
            }
          }
        }
        if(theme.utils.metrics.scrollDir == 'up') {
          self.$siteHeader.removeClass('is-shrinked').removeClass('is-hidden');
        }
      }
    });

    // For main slideshow slides
    if($('.section-slideshow .swiper-slide').not('.swiper-slide-duplicate').first().hasClass('is-light') || $('.hero-header').hasClass('is-light')) {
      self.$siteHeader.addClass('is-light');
    } else {
      self.$siteHeader.removeClass('is-light');
    }

    // For heroheader pages
    if(window.theme.settings.header.isLight) {
      self.$siteHeader.addClass('is-light');
    }
    if(window.theme.settings.header.transparentHeaderAllowed && !window.theme.settings.header.pageHasHero) {
      this.$siteHeader.removeClass('is-transparent');
    }

    self.$siteHeader.removeClass('hide');


    // ========== Search  Panel ==========
    $('.menu>.search').unbind('click').bind('click', function() {
      if($('#searchPanel .content').hasClass('active')) {
        return false;
      }

      self.headerWasTransparent = $('header').hasClass('is-transparent');
      self.headerWasExpanded = $('header').hasClass('is-expanded');
      $('header')
        .removeClass('is-transparent')
        .removeClass('is-expanded')
        .removeClass('is-shrinked');

      self.headerLocked = true;

      function theEvent(e) {
        if ($(e.target).parents("#searchPanel").length === 0) {
          $('#searchPanel').accordion('close', 0);

          if(self.headerWasTransparent) {
            $('header').addClass('is-transparent');
          }
          if(self.headerWasExpanded) {
            $('header').addClass('is-expanded');
          }
        }
      }

      $('#searchPanel').accordion({'onClosing': function() {
        $('body').off('click', theEvent);
        //$('#searchPanel .content').removeClass('active');
        self.headerLocked = false;
      }});

      $('#searchPanel').accordion('open', 0);

      setTimeout(function() {
        $('body').one('click', theEvent);
      }, 100);
    });
  },
  expand: function() {
    if(window.theme.settings.header.transparentHeaderAllowed && window.theme.settings.header.pageHasHero && !this.headerLocked) {
      this.$siteHeader.addClass('is-transparent');
    }
    if(window.theme.settings.header.expandableHeaderAllowed && !this.headerLocked) {
      this.$siteHeader.addClass('is-expanded');
      $('body').addClass('header-is-expanded');
    }
  },
  shrink: function() {
    if(window.theme.settings.header.transparentHeaderAllowed && window.theme.settings.header.pageHasHero && !this.headerLocked) {
      this.$siteHeader.removeClass('is-transparent');
    }
    if(window.theme.settings.header.expandableHeaderAllowed && !this.headerLocked) {
      this.$siteHeader.removeClass('is-expanded');
      $('body').removeClass('header-is-expanded');
    }
  },
  resize: function() {
    this.shrinkPoint = $('.hero').height();
  }
}



// ========== Ajax Cart ==========
var CartJSinitialized = false;
theme.ajaxCart = {
  isReady: false,
  init: function() {
    var $oderNoteForm = $('.order-note-form'),
        $ajaxCart = $('#ajaxCart'),
        self = this;
  
    // RivetsJS
    rivets.formatters.translate = function(value, id){
      if(typeof theme.cartTranslations[id] !== 'undefined') {
        return theme.cartTranslations[id]['title'];
      }else{
        return value;
      }
    }
    rivets.formatters.is_audio = function(value) {
      if(value === 'audio') {
        return true;
      }
    }
    rivets.formatters.plus = function(value) {
      if(typeof value !== 'undefined') {
        return value + 1;
      }
    }
    rivets.formatters.minus = function(value) {
      if(typeof value !== 'undefined') {
        return value - 1;
      }
    }
    rivets.binders.src = function(el, src) {
      $(el).attr('src', src);
    };
    rivets.binders.href = function (el, value) {
      $(el).attr('href', value);
    }
    rivets.binders['data-cart-update'] = function (el, value) {
      $(el).attr('data-cart-update', value);
    }
    rivets.binders['data-cart-quantity'] = function (el, value) {
      $(el).attr('data-cart-quantity', value);
    }

    var cartModel = {
      cart: CartJS.cart,
      openOrderNoteForm: function() {
        $oderNoteForm.find('textarea').val(CartJS.getNote());
        $ajaxCart.dimmer({ 
          closable: true,
          onHide: function() {
            $oderNoteForm.transition({
              animation  : 'fade up out',
              duration   : '.5s'
            });
          }
        }).dimmer('show');
        $oderNoteForm.transition({
          animation  : 'fade up in',
          duration   : '.5s'
        });
      },
      closeOrderNoteForm: function() {
        CartJS.setNote($oderNoteForm.find('textarea').val());
        $ajaxCart.dimmer('hide');
      }
    };
  
    // CartJS
    if(!CartJSinitialized) {
      CartJS.init(window.theme.cart, {
        debug: false,
        moneyFormat: theme.moneyFormat,
        moneyWithCurrencyFormat: theme.moneyWithCurrencyFormat,
        rivetsModels: cartModel
      });    
      CartJSinitialized = true;
    } else {
      // Wenn instantclick aktiv & CartJS bereits initiiert,
      // dann die cart-view in riverts neu binden
      rivets.bind($('[data-cart-view]'), cartModel);
    }


    $(document).off('cart.ready').on('cart.ready', function(event, cart) {
      console.log('cart.ready', cart);
    });
    $(document).off('cart.requestStarted').on('cart.requestStarted', function(event, cart) {
      //console.log('cart.requestStarted', event, cart);
    });
    $(document).off('cart.requestComplete').on('cart.requestComplete', function(event, cart) {
      //console.log('cart.requestComplete', event, cart);
      window.theme.cart = cart;

      $('.add-to-cart-btn.loading').removeClass("loading");
      $('.cart-count').text(cart.item_count);

      if(theme.mediaPlayer.useCartPlaylist) {
        theme.cartPlaylist.resetPlaylist();
      }
    });


    // Sidebar Animations
    const $cartPlaylistPlayer = $('#cartPlaylistPlayer');
    $('#sidebarCart').sidebar({
      exclusive: false,
      scrollLock: true,
      onShow: () => {
        if(theme.cart.items.length > 0) {
          $('#ajaxCart .sidebar-header').transition('slide down in');
          $('#ajaxCart .cart-meta.item').transition({
            animation: 'slide up in',
            onComplete: function() {
              $('#ajaxCart .list-scroll-container .item').transition({
                animation : 'scale',
                duration  : 500,
                interval  : 100
              });
              if($('.cart-playlist-action').length != 0) {
                setTimeout(function() {
                  $cartPlaylistPlayer.transition('slide up in');
                }, 100);
              }
            }
          });
        }

      },
      onHide: () => {
        if(theme.cart.items.length > 0) {
          $('#ajaxCart .list-scroll-container .item').transition('scale out');
          $('#ajaxCart .cart-meta.item').transition('slide up out');
          $('#ajaxCart .sidebar-header').transition('slide down out');
          $cartPlaylistPlayer.transition({
            animation: 'slide up out',
            onComplete: function() {
            }
          });
        }
      }
    })
    .sidebar('setting', 'transition', 'overlay')
    .sidebar('attach events', '.cart-btn');
  }
}



// ========== Google Maps ==========
theme.initGoogleMaps = function() {
  if($('#map').length > 0){
    $('#map').each(function() {
      var map = new GMaps({
        div: '#map',
        lat: $(this).data('lat'),
        lng: $(this).data('lng'),
        mapTypeControlOptions: {
          //mapTypeIds : ["hybrid", "roadmap", "satellite", "terrain", "blueprint", "cloudmade"]
          mapTypeIds : ["osm", "roadmap"]
        }
      });

      map.addMarker({
        lat: $(this).data('lat'),
        lng: $(this).data('lng'),
        title: 'Lima',
        infoWindow: {
          content: '<p>'+ $(this).data('content') +'</p>'
        },
        click: function(e) {}
      });

      map.addMapType("osm", {
        getTileUrl: function(coord, zoom) {
          return "https://stamen-tiles.a.ssl.fastly.net/toner/" + zoom + "/" + coord.x + "/" + coord.y + ".png";
        },
        tileSize: new google.maps.Size(256, 256),
        name: "Blueprint",
        maxZoom: 18
      });
      map.addMapType("cloudmade", {
        getTileUrl: function(coord, zoom) {
          return "http://b.tile.cloudmade.com/8ee2a50541944fb9bcedded5165f09d9/1/256/" + zoom + "/" + coord.x + "/" + coord.y + ".png";
        },
        tileSize: new google.maps.Size(256, 256),
        name: "CloudMade",
        maxZoom: 18
      });

      map.setMapTypeId('osm');

      /*
      map.drawOverlay({
        lat: $(this).data('lat'),
        lng: $(this).data('lng'),
        content: '<div class="overlay">Lima</div>'
      });
      */
    });
	}
}



// ========== Slate Stuff  ==========
theme.initSlateStuff = function() {
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });
}



// ========== Langify App Support ==========
theme.initLangifySupport = function() {
  
  if(typeof langify === 'undefined') {
    return false;
  }

  $('.language-switcher').dropdown({
    on: 'click',
    transition: 'drop',
    onChange: function(value, text, $choice) {
      langify.helper.saveLanguage(value);
    }
  });

  // JS Translations
  var $jsTranslations = $('#jsTranslations');
  if($('#jsTranslations').length > 0) {
    $jsTranslations.find('span').each(function(index, item) {
      theme.strings[$(item).attr('id')] = $(item).html();
    });
  }
}



// ========== Geolizr App Support ==========
theme.initGeolizrSupport = function() {
  
  if(typeof Geolizr === 'undefined') {
    return false;
  }

  Geolizr.init(($) => {
    Geolizr.addEventListener('currency.change', function(currency) {
      $('.currency-switcher').dropdown('set selected', currency);
    });

    $('.currency-switcher').dropdown({
      on: 'click',
      transition: 'drop',
      onChange: function(value, text, $choice) {
        Geolizr.setCurrency(value);
      }
    });
  });
}



// ========== Theme Utilities ==========
theme.utils = {
  metrics: {
    lastScrollTop: 0,
    scrollDir: 'none'
  },
  inIframe: function() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  },

  getREM: function(val) {
    return 14 * val * theme.settings.gridSpacing;
  },

  getEM: function(fontSize, val) {
    return fontSize * val * theme.settings.gridSpacing;
  },

  isMobileDevice: function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  },

  isMobileOrTabletDevice: function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  },

  isChrome: /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)

}













$(document).on('shopify:section:load', function(e){
  //console.log('shopify:section:load - ' + e.detail.sectionId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  theme.initLayout();
  theme.header.init();
});

/*
$(document).on('shopify:block:select', function(e){
  //console.log('shopify:block:select - ' + e.detail.sectionId + ' - ' + e.detail.blockId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:section:unload', function(e){
  //console.log('shopify:section:unload - ' + e.detail.sectionId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:section:select', function(e){
  //console.log('shopify:section:select - ' + e.detail.sectionId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:section:deselect', function(e){
  //console.log('shopify:section:deselect - ' + e.detail.sectionId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:section:reorder', function(e){
  //console.log('shopify:section:reorder - ' + e.detail.sectionId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:block:deselect', function(e){
  //console.log('shopify:block:deselect - ' + e.detail.sectionId + ' - ' + e.detail.blockId);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});
*/







$(document).ready(function() {
  // Auf der Passwortseite hier aussteigen
  if(location.pathname.substring(1).indexOf('password') == 0) {
    return false;
  }

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

if(theme.settings.instantMode) {
  if(!theme.utils.inIframe()) {
    theme.initThemeApp();
  } else {
    $(window).on('load', theme.initTheme());
  }
} else {
  $(window).on('load', theme.initTheme());
}



